import React from "react";
import { getApplicationCertificates } from "../../helpers/backend_helper";
import CertificateDetail from "./CertificateDetail";
import SettingsList from "./SettingsList";

const SettingsCertificates = () => (
  <SettingsList
    title="Certificates"
    description="Manage the certificates and credentials used by your organization."
    singularLabel="Certificate"
    nameKey="certificateName"
    descriptionKey="certificateDesc"
    loadItems={getApplicationCertificates}
    DetailComponent={CertificateDetail}
    icon="bx-certification"
    fileName="certificates"
  />
);

export default SettingsCertificates;
